module.exports = __webpack_public_path__ + "static/media/EE1.b942a181.PNG";